import script from "./Top.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top.vue?vue&type=script&setup=true&lang=ts"

import "./Top.vue?vue&type=style&index=0&id=4d7a869d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7a869d"]])

export default __exports__